module.exports = __webpack_public_path__ + "static/abstract02-0fadbd362db09f00d0550ad6a339745d.jpg";